export default __webpack_public_path__ + "static/media/tiktok.d7f4a830.png";